module.exports = __webpack_public_path__ + "img/homepage-bottom-cta@4x.459c18e.jpg";